import Button from "components/Button/index";
// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import useScreenMobile from "hooks/useScreen";
import successAnime from "assets/json/success.json";
import failureAnime from "assets/json/failure.json";

import "./success.scss";
const Success = ({
  title = "",
  titleWidth = "",
  titleMobileWidth = "",
  subTitle = "",
  subTitleWidth = "",
  subTitleMobileWidth = "",
  buttonText = "",
  buttonPlus = "",
  image,
  altText = "",
  imgWidth = "",
  imgHeight = "",
  imgMaxheight = "",
  imgMaxwidth = "",
  onClick,
  password,
  success,
  background = false,
  btn = true
}) => {
  const isMobile = useScreenMobile({ size: 568 });
  // const navigate = useNavigate();

  // const func = () => {
  //   if (password) {
  //     const isReset = true;
  //     setTimeout(() => {
  //       navigate("/resetpassword", { state: isReset });
  //     }, 5000);
  //   } else {
  //     // navigate("/resetpassword");
  //     // navigate("/userList");
  //   }
  // };

  // useEffect(() => {
  //   func();
  // }, []);
  const lottieImage = success ? successAnime : failureAnime;

  return (
    <>
      <section
        className="account"
        // style={
        //   paymentStyle ? { height: "fit-content", width: "fit-content" } : {}
        // }
        style={{
          backgroundImage: background && "none",
          backgroundColor: background && "transparent",
          padding: background && "0"
        }}
      >
        <div className="container accountContainer">
          <div className="accountBox">
            {!image && (
              <Lottie
                animationData={lottieImage}
                loop={true}
                style={{ height: 120, width: 120 }}
                className="lottie"
              />
            )}
            {image && (
              <div
                className="imageWrapper"
                style={{
                  maxWidth: imgMaxwidth,
                  maxHeight: imgMaxheight,
                  height: imgHeight,
                  width: imgWidth
                }}
              >
                <img src={image} alt={altText} />
              </div>
            )}
            <div className="commonHeading">
              <h1
                style={{ maxWidth: isMobile ? titleMobileWidth : titleWidth }}
              >
                {title}
              </h1>
              <p
                style={{
                  maxWidth: isMobile ? subTitleMobileWidth : subTitleWidth
                }}
              >
                {subTitle}
              </p>
            </div>
            <Button
              type="violet"
              title={buttonText}
              showImage={buttonPlus}
              onClick={() => {
                onClick();
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Success;
